module.exports = function(app) {
    app.directive('effectiveDateValidation', ["$window", "$compile","modal", 'sessionData','$rootScope','storage', function($window, $compile, modal, sessionData, $rootScope, storage) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, elm, attrs, ctrl) {

                ctrl.$validators.effectiveDateValidation = function (modelValue, viewValue) {
                    var asoValue = sessionData.entitlements.clientQualifiers.aso;
                    if (modelValue instanceof Date) {
                        var isCobra = storage.get('isCobra');
                        var today = new Date();
                        // var dtHire = new Date(scope.subscriberInfoForm.hired.$viewValue);
                        function truncateToDay(date) {
                            date.setHours(0);
                            date.setMinutes(0);
                            date.setSeconds(0);
                            date.setMilliseconds(0);
                            return date;
                        }


                        var enteredDate = modelValue;
                        var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                        var firstDayOfMonthMinus3Y = new Date(firstDayOfMonth.getFullYear() - 3, firstDayOfMonth.getMonth(), 1);
                        var firstDayOfMonthMinus6Mo = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() - 6, 1);
                        var firstDayOfMonthMinus1Mo = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() - 1, 1);
                        var d15thPrePre = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() - 2, 15);
                        var todayPlus90D = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 91);

                        // var todayPlus90D = new Date(dtHire.getFullYear(), dtHire.getMonth(), dtHire.getDate()+92);
                        var beforeDate = '';
                        var changeDate = '';
                        var afterDate = '';
                        if (window.location.href.indexOf('/add/subscriber') !== -1) {
                            if (scope.employee.data.subscriber.eventDate instanceof Date) {
                                if (scope.employee.data.subscriber.eventCode) {
                                    var newArray = [];
                                    newArray = scope.lifeEventValues.filter(function (el) {
                                        return el.lifeEventId === scope.employee.data.subscriber.eventCode;
                                    });
                                    scope.beforeDate = new Date(scope.employee.data.subscriber.eventDate.getFullYear(), scope.employee.data.subscriber.eventDate.getMonth(), scope.employee.data.subscriber.eventDate.getDate() - parseInt(newArray[0].beforeDays));
                                    scope.afterDate = new Date(scope.employee.data.subscriber.eventDate.getFullYear(), scope.employee.data.subscriber.eventDate.getMonth(), scope.employee.data.subscriber.eventDate.getDate() + parseInt(newArray[0].afterDays));
                                    beforeDate = truncateToDay(new Date(scope.beforeDate));
                                    changeDate = truncateToDay(new Date(modelValue));
                                    afterDate = truncateToDay(new Date(scope.afterDate));
                                }
                            }
                        }
                        if (window.location.href.indexOf('/find/review') !== -1) {
                            if (scope.$parent.findReviewForm && scope.$parent.findReviewForm.editCardSepForm && scope.$parent.findReviewForm.editCardSepForm.lifeEventDate) {
                                if (scope.$parent.findReviewForm.editCardSepForm.lifeEventDate.$modelValue instanceof Date) {
                                    var lifeEventDate = scope.$parent.findReviewForm.editCardSepForm.lifeEventDate.$modelValue;
                                    if (scope.$parent.findReviewForm.editCardSepForm.lifeEventReason) {
                                        var lifeEventReason = scope.$parent.findReviewForm.editCardSepForm.lifeEventReason.$modelValue;
                                        scope.beforeDate = new Date(lifeEventDate.getFullYear(), lifeEventDate.getMonth(), lifeEventDate.getDate() - parseInt(lifeEventReason.beforeDays));
                                        scope.afterDate = new Date(lifeEventDate.getFullYear(), lifeEventDate.getMonth(), lifeEventDate.getDate() + parseInt(lifeEventReason.afterDays));
                                        beforeDate = truncateToDay(new Date(scope.beforeDate));
                                        changeDate = truncateToDay(new Date(scope.employee.data.globalCoverageEffectiveDate));
                                        afterDate = truncateToDay(new Date(scope.afterDate));
                                    }
                                }
                            }
                        }
                        if (window.location.href.indexOf('/manage-employees/cancel-coverage') !== -1) {
                            if (scope.lifeEventDate instanceof Date && scope.lifeEventReason) {
                                scope.beforeDate = new Date(scope.lifeEventDate.getFullYear(), scope.lifeEventDate.getMonth(), scope.lifeEventDate.getDate() - parseInt(scope.lifeEventReason.beforeDays));
                                scope.afterDate = new Date(scope.lifeEventDate.getFullYear(), scope.lifeEventDate.getMonth(), scope.lifeEventDate.getDate() + parseInt(scope.lifeEventReason.afterDays));
                                beforeDate = truncateToDay(new Date(scope.beforeDate));
                                changeDate = truncateToDay(new Date(scope.cancellationForm.cancelDate.$$rawModelValue));//cancellationForm
                                afterDate = truncateToDay(new Date(scope.afterDate));
                            }
                        }
                        function checkBretvel() {
                            if (window.location.href.indexOf('/add/subscriber') !== -1 && scope.employee.data.subscriber.eventDate && scope.employee.data.subscriber.eventDate) {
                                return (changeDate >= beforeDate && changeDate <= afterDate);
                            }

                            else if (window.location.href.indexOf('/find/review') !== -1 && scope.$parent.findReviewForm.editCardSepForm.lifeEventDate && scope.$parent.findReviewForm.editCardSepForm.lifeEventReason) {
                                return (changeDate >= beforeDate && changeDate <= afterDate);
                            }
                            else if (window.location.href.indexOf('/manage-employees/cancel-coverage') !== -1 && scope.lifeEventDate && scope.lifeEventReason) {
                                return (changeDate >= beforeDate && changeDate <= afterDate);
                            }
                            else {
                                return false;
                            }
                        }
                        ///find/add-coverage
                        var nDays = enteredDate - firstDayOfMonth;

                        var bRetval = false;
                        if (asoValue) {

                            bRetval = ( (enteredDate >= firstDayOfMonthMinus3Y) && (enteredDate < todayPlus90D) );
                            if (!bRetval && scope.hasSEP && scope.outSideOpen) {
                                bRetval = checkBretvel();
                            }
                            if ((enteredDate < firstDayOfMonthMinus6Mo) && (enteredDate > firstDayOfMonthMinus3Y ) && (window.location.href.indexOf('/add/subscriber') < 0) && (window.location.href.indexOf('/add/coverage') < 0) ){
                                modal.open({
                                               template: require('pages/employee/modals/asoEffectiveDateModal.html'),
                                               scope: scope
                                           });
                            }
                        }

                        else {
                            if (
                                (scope.employee &&
                                scope.employee.data &&
                                scope.employee.data.subscriber &&
                                scope.employee.data.subscriber.cobra &&
                                scope.employee.data.subscriber.cobra.value
                            ) || isCobra ){
                                bRetval = ( (enteredDate >= d15thPrePre) && (enteredDate < todayPlus90D) );
                                if (!bRetval && scope.hasSEP && scope.outSideOpen) {
                                    bRetval = checkBretvel();
                                }
                            }
                            else {
                                bRetval = ( (enteredDate >= firstDayOfMonthMinus1Mo) && (enteredDate < todayPlus90D) );
                                if (!bRetval && scope.hasSEP && scope.outSideOpen) {
                                    bRetval = checkBretvel();
                                }
                            }
                        }

                        return bRetval;
                    }
                    else {
                        return undefined;
                    }
                };


            }
        };
    }]);
};
